<section id="summary-experience" name="summary-experience">
	<div id="intro">
		<div class="container">
			<div class="row">
				<div class="col-lg-2 col-lg-offset-1">
					<h5><i class="fa fa-user"></i>SUMMARY EXPERIENCE</h5>
				</div>
				<div class="col-lg-9">
					<li *ngFor="let summary of summaries; let i = index">
						{{ summary.text }}
					</li>
				</div>
			</div>
			<hr />
		</div>
	</div>
</section>
